import React, { useState } from 'react';
import styled from 'styled-components';

// SVG 아이콘들을 직접 컴포넌트로 정의
const InstagramIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="currentColor"/>
    </svg>
);

const FacebookIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.198 21.5h4v-8.01h3.604l.396-3.98h-4V7.5a1 1 0 0 1 1-1h3v-4h-3a5 5 0 0 0-5 5v2.01h-2l-.396 3.98h2.396v8.01z" fill="currentColor"/>
    </svg>
);

const KakaoIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3C6.5 3 2 6.3 2 10.4c0 2.7 1.8 5.1 4.5 6.4-.2.7-.7 2.5-.8 2.9-.1.5.2.5.4.3.2-.1 2.6-1.8 3.7-2.5.7.1 1.4.2 2.1.2 5.5 0 10-3.3 10-7.4 0-4.1-4.5-7.3-10-7.3z" fill="currentColor"/>
    </svg>
);

// 스타일 컴포넌트 정의
const DrawerContainer = styled.div`
    position: fixed;
    right: ${props => props.isOpen ? '0' : '-60px'};
    top: 40%;
    transform: translateY(-50%);
    display: flex;
    transition: right 0.3s ease-in-out;
    z-index: 999;
`;

const DrawerTab = styled.div`
    width: 40px;
    height: 120px;
    background-color: #2B4F95; /* 중앙대학교 블루 */
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: -3px 0 10px rgba(0, 0, 0, 0.1);

    &::before {
        content: '';
        width: 20px;
        height: 20px;
        border-top: 3px solid white;
        border-left: 3px solid white;
        transform: ${props => props.isOpen ? 'rotate(135deg)' : 'rotate(-45deg)'};
        margin-bottom: 10px;
        transition: transform 0.3s ease;
    }

    span {
        writing-mode: vertical-rl;
        text-orientation: mixed;
        color: white;
        font-weight: bold;
        letter-spacing: 2px;
        transform: rotate(180deg);
    }
`;

const DrawerContent = styled.div`
    background-color: white;
    width: 60px;
    height: auto;
    padding: 15px 0;
    box-shadow: -3px 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const SocialLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 10px 0;
    background-color: ${props => props.bgColor};
    color: ${props => props.textColor};
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
`;

const FloatingDrawer = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    return (
        <DrawerContainer isOpen={isOpen}>
        <DrawerTab isOpen={isOpen} onClick={toggleDrawer}>
            <span>SNS</span>
        </DrawerTab>
        
        <DrawerContent>
            <SocialLink 
            href="https://www.instagram.com/cau_dah.eum/" 
            target="_blank" 
            rel="noopener noreferrer"
            bgColor="#E4405F"
            textColor="white"
            aria-label="Instagram"
            >
            <InstagramIcon />
            </SocialLink>
            
            {/* <SocialLink 
            href="https://www.facebook.com/caugsa" 
            target="_blank" 
            rel="noopener noreferrer"
            bgColor="#1877F2"
            textColor="white"
            aria-label="Facebook"
            >
            <FacebookIcon />
            </SocialLink> */}
            
            <SocialLink 
            href="https://pf.kakao.com/_wLfZd" 
            target="_blank" 
            rel="noopener noreferrer"
            bgColor="#FAE100"
            textColor="#3C1E1E"
            aria-label="KakaoTalk"
            >
            <KakaoIcon />
            </SocialLink>
        </DrawerContent>
        </DrawerContainer>
    );
};

export default FloatingDrawer;